import axios from 'axios';

const API = process.env.VUE_APP_BASE_URI.replace("api/", "");

export default {
    getCountries({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/countries`)
                .then(({
                    data: {
                        data
                    }
                }) => {
                    commit('SET_COUNTRIES', data);
                    resolve();
                })
                .catch(error => reject(error.response));
        });
    },
    getStates({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/states`)
                .then(({
                    data: {
                        data
                    }
                }) => {
                    commit('SET_STATES', data);
                    resolve();
                })
                .catch(error => reject(error.response));
        });
    },
    getCities({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get(`${API}/cities`)
                .then(({
                    data: {
                        data
                    }
                }) => {
                    commit('SET_CITIES', data);
                    resolve();
                })
                .catch(error => reject(error.response));
        });
    },
    // filters({commit},url) {
    //     return new Promise((resolve,reject) => {
    //         axios.get(`${API}/${url}`);
    //     })

    // }

}